// url sviluppo
//const loopbackUrl = 'http://52.51.88.98/api';

// Modifica per gestione url con environment
//const loopbackUrl = 'http://'+process.env.+'/api';
const loopbackUrl = process.env.REACT_APP_API_URL;

// url produzione
// const loopbackUrl = 'https://minosliveapi.umpi.it/api';

export default loopbackUrl


// WEBPACK FOOTER //
// ./src/constants/loopbackUrl.js